var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.90303 5.43136L1.89601 5.44453C1.73236 5.77375 1.3926 6 1 6C0.447715 6 0 5.55228 0 5C0 4.82687 0.0439963 4.66402 0.121416 4.52202C0.127503 4.51037 0.135171 4.49591 0.144443 4.4788C0.165759 4.43944 0.195592 4.38598 0.234218 4.32043C0.311401 4.18946 0.424121 4.0095 0.574654 3.79698C0.874948 3.37304 1.3305 2.81276 1.96069 2.25259C3.22948 1.12478 5.20726 0 8.00005 0C10.7928 0 12.7706 1.12478 14.0394 2.25259C14.6696 2.81276 15.1252 3.37304 15.4255 3.79698C15.576 4.0095 15.6887 4.18946 15.7659 4.32043C15.8045 4.38598 15.8343 4.43944 15.8557 4.4788C15.8663 4.49848 15.8749 4.51465 15.8813 4.52706C15.957 4.66781 16 4.82903 16 5C16 5.55228 15.5523 6 15 6C14.6063 6 14.2657 5.77245 14.1026 5.44169L14.0971 5.43136C14.0867 5.41212 14.0686 5.37965 14.0428 5.33582C13.9911 5.24804 13.9085 5.1155 13.7934 4.95302C13.5624 4.62696 13.2055 4.18724 12.7107 3.74741C11.7295 2.87522 10.2073 2 8.00005 2C5.79285 2 4.27063 2.87522 3.28942 3.74741C2.79461 4.18724 2.43766 4.62696 2.2067 4.95302C2.09161 5.1155 2.00902 5.24804 1.95729 5.33582C1.93147 5.37965 1.91345 5.41212 1.90303 5.43136Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 7C11 8.65685 9.65685 10 8 10C6.34315 10 5 8.65685 5 7C5 5.34315 6.34315 4 8 4C9.65685 4 11 5.34315 11 7ZM10 6C10 6.55228 9.55228 7 9 7C8.44772 7 8 6.55228 8 6C8 5.44772 8.44772 5 9 5C9.55228 5 10 5.44772 10 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.dd1038b1ac544a56a9528ac794344682.svg";
export { ForwardRef as ReactComponent };